/* plantas finas — Aufklappmenüs auf der Produktseite

   Zerlegt die vorhandene Produktbeschreibung in aufklappbare Bereiche,
   ohne dass dafür Daten umgezogen werden müssen.

   Die Beschreibungen sind über die Jahre unterschiedlich ausgezeichnet
   worden. Drei Schreibweisen kommen vor, alle drei werden erkannt:

     1. <div class="info-block"><h3>Zutaten</h3> ... </div>
     2. <h3>Verzehrempfehlung</h3><p> ... </p>
     3. <p><b>Zutaten:</b> ... </p>          <- häufigste Variante

   Fall 3 wird nur dann als Überschrift gewertet, wenn der fette Text am
   Absatzanfang steht und entweder mit Doppelpunkt endet oder einem der
   bekannten Begriffe entspricht. Sonst würde jede Fettung im Fließtext
   einen neuen Bereich aufmachen — etwa "· 90 vegane Kapseln" ganz oben,
   das ist Einleitung und keine Überschrift.

   WICHTIG — der Pflichthinweis-Kasten (.legal-box) wird bewusst NICHT
   eingeklappt und ans Ende gestellt. Aufklappmenüs sind nach Art. 14
   LMIV zulässig, weil die Angaben auf derselben Seite vor dem Kauf
   erreichbar bleiben. Bei den Warnhinweisen nach § 4 NemV ist die
   sichtbare Variante aber die, die niemand angreift — es sind drei Zeilen.

   Fällt JavaScript aus, bleibt die Beschreibung unverändert und
   vollständig sichtbar. Das ist bei Pflichtangaben der richtige
   Fehlerfall: lieber zu viel Text als fehlender Text. */

(function () {
  'use strict';

  /* Begriffe, die auch ohne Doppelpunkt als Überschrift zählen */
  var BEGRIFFE = /^(zutaten|nährwert|naehrwert|inhaltsstoffe|verzehr|anwendung|dosierung|aufbewahrung|lagerung|produktmerkmale|qualität|herkunft|allergene|hinweise)/i;

  function saubererTitel(text) {
    return (text || '')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/^[•·–—\-\s]+/, '')
      .replace(/[:·\-\s]+$/, '');
  }

  /* Liefert das Überschrift-Element eines Blocks oder null */
  function ueberschriftVon(el) {
    if (el.tagName === 'H2' || el.tagName === 'H3' || el.tagName === 'H4') return el;

    var h = el.querySelector ? el.querySelector(':scope > h2, :scope > h3, :scope > h4') : null;
    if (h) return h;

    /* Fall 3: fetter Text am Absatzanfang */
    var erstes = el.firstElementChild;
    if (!erstes) return null;
    if (erstes.tagName !== 'B' && erstes.tagName !== 'STRONG') return null;

    /* Steht wirklich am Anfang? Kein Text davor. */
    var davor = '';
    var n = el.firstChild;
    while (n && n !== erstes) {
      davor += n.textContent || '';
      n = n.nextSibling;
    }
    if (davor.replace(/\s+/g, '').length) return null;

    var t = (erstes.textContent || '').replace(/\s+/g, ' ').trim();
    if (!t || t.length > 45) return null;
    if (!/:$/.test(t) && !BEGRIFFE.test(t)) return null;

    return erstes;
  }

  function bauen() {
    var quelle = document.querySelector('.product__description');
    if (!quelle || quelle.querySelector('.pf-acc')) return;

    var kinder = Array.prototype.slice.call(quelle.children);
    if (!kinder.length) return;

    var bereiche = [];
    var einleitung = [];
    var pflicht = [];
    var aktuell = null;

    kinder.forEach(function (el) {
      if (el.classList && el.classList.contains('legal-box')) {
        pflicht.push(el);
        return;
      }

      if (!el.textContent.replace(/\s+/g, '').length && !el.querySelector('img')) return;

      var h = ueberschriftVon(el);

      if (h) {
        aktuell = { titel: saubererTitel(h.textContent), inhalt: [] };
        bereiche.push(aktuell);

        /* Eigenständige Überschrift: Inhalt folgt in den nächsten Blöcken */
        if (h === el) return;

        /* Überschrift steckt im Block: Rest des Blocks ist der Inhalt.
           Bei <p><b>Zutaten:</b> Text</p> bleibt der Text im selben
           Absatz — deshalb den Absatz übernehmen und nur die Fettung
           daraus entfernen. */
        if (h.parentNode === el && (el.tagName === 'P' || el.tagName === 'DIV')) {
          h.parentNode.removeChild(h);
          if (el.textContent.replace(/\s+/g, '').length) aktuell.inhalt.push(el);
          return;
        }

        Array.prototype.slice.call(el.childNodes).forEach(function (n) {
          if (n !== h) aktuell.inhalt.push(n);
        });
        return;
      }

      if (aktuell) aktuell.inhalt.push(el);
      else einleitung.push(el);
    });

    if (!bereiche.length) return;

    if (einleitung.length) {
      bereiche.unshift({ titel: 'Produktbeschreibung', inhalt: einleitung });
    }

    var huelle = document.createElement('div');
    huelle.className = 'pf-acc-wrap';

    bereiche.forEach(function (b, i) {
      var d = document.createElement('details');
      d.className = 'pf-acc';
      if (i === 0) d.open = true;

      var s = document.createElement('summary');
      s.className = 'pf-acc__kopf';
      s.textContent = b.titel;
      d.appendChild(s);

      var body = document.createElement('div');
      body.className = 'pf-acc__inhalt';
      b.inhalt.forEach(function (n) { body.appendChild(n); });
      d.appendChild(body);

      huelle.appendChild(d);
    });

    quelle.innerHTML = '';
    quelle.appendChild(huelle);

    pflicht.forEach(function (p) { quelle.appendChild(p); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bauen);
  } else {
    bauen();
  }
})();
